export default "__VITE_PUBLIC_ASSET__8ead190c__"